import { Command } from './Command';
import { ChartEngine, MaskConfig } from '../core/ChartEngine';

/**
 * 레이어에 마스크를 추가하거나 업데이트하는 커맨드
 */
export class AddMaskCommand implements Command {
  private previousMask: MaskConfig | null = null;
  private isNewMask: boolean = true;

  constructor(
    private regionId: string,
    private layerId: string,
    private mask: MaskConfig
  ) {}

  execute(engine: ChartEngine): void {
    const snapshot = engine.getSnapshot();
    const region = snapshot.find(r => r.id === this.regionId);
    const layer = region?.layers.find(l => l.id === this.layerId);

    if (layer) {
      // Undo를 위해 이전 상태 저장
      const existingMask = layer.masks?.find(m => m.id === this.mask.id);
      if (existingMask) {
        this.previousMask = { ...existingMask };
        this.isNewMask = false;
      }
      
      engine.addMaskToLayer(this.regionId, this.layerId, this.mask);
    }
  }

  undo(engine: ChartEngine): void {
    if (this.isNewMask) {
      // 새로 추가했던 것이라면 제거
      engine.removeMaskFromLayer(this.regionId, this.layerId, this.mask.id);
    } else if (this.previousMask) {
      // 기존 것을 수정했던 것이라면 이전 데이터로 복구
      engine.addMaskToLayer(this.regionId, this.layerId, this.previousMask);
    }
  }
}

/**
 * 레이어에서 특정 마스크를 제거하는 커맨드
 */
export class RemoveMaskCommand implements Command {
  private removedMask: MaskConfig | null = null;

  constructor(
    private regionId: string,
    private layerId: string,
    private maskId: string
  ) {}

  execute(engine: ChartEngine): void {
    const snapshot = engine.getSnapshot();
    const region = snapshot.find(r => r.id === this.regionId);
    const layer = region?.layers.find(l => l.id === this.layerId);
    
    // Undo를 위해 삭제될 데이터 백업
    const mask = layer?.masks?.find(m => m.id === this.maskId);
    if (mask) {
      this.removedMask = { ...mask };
      engine.removeMaskFromLayer(this.regionId, this.layerId, this.maskId);
    }
  }

  undo(engine: ChartEngine): void {
    if (this.removedMask) {
      // 삭제했던 마스크 다시 추가
      engine.addMaskToLayer(this.regionId, this.layerId, this.removedMask);
    }
  }
}